module.exports = angular.module('eatself').component('seatInput',{
	bindings: {
		seat: '<',
	},
	controllerAs: 'vm',
	template: `
<div ng-class="{'invalid':vm.seat.error}" class="has-float-label lineInput mt-20">	
	<input id="seat-text" type="text" class="form-item" ng-model="vm.seat.value" placeholder="{{vm.seat.placeholder}}">
	<label for="seat-text" ng-if="vm.seat.label">{{vm.seat.label}}</label>		
</div>
<div ng-show="vm.seat.error" class="color-bo-danger mt-5">{{vm.seat.label}} obligatoire</div>
`,
})
